export const GET_ORDER_ENTRY_INVESTOR_LIST = "GET_ORDER_ENTRY_INVESTOR_LIST"
export const GET_ORDER_ENTRY_INVESTOR_LIST_SUCCESS = "GET_ORDER_ENTRY_INVESTOR_LIST_SUCCESS"

export const ADD_ORDER_ENTRY_SUCCESS = "ADD_ORDER_ENTRY_SUCCESS"
export const ADD_ORDER_ENTRY = "ADD_ORDER_ENTRY"

export const PRODUCT_TYPE_FILTER_SUCCESS = "PRODUCT_TYPE_FILTER_SUCCESS"
export const PRODUCT_TYPE_FILTER = "PRODUCT_TYPE_FILTER"

export const TRANSACTION_TYPE_FILTER_SUCCESS = "TRANSACTION_TYPE_FILTER_SUCCESS"
export const TRANSACTION_TYPE_FILTER = "TRANSACTION_TYPE_FILTER"

export const PAYMENT_TYPE_FILTER_SUCCESS = "PAYMENT_TYPE_FILTER_SUCCESS"
export const PAYMENT_TYPE_FILTER = "PAYMENT_TYPE_FILTER"

export const APPROVAL_TYPE_FILTER_SUCCESS = "APPROVAL_TYPE_FILTER_SUCCESS"
export const APPROVAL_TYPE_FILTER = "APPROVAL_TYPE_FILTER"

export const ORDER_HISTORY_LIST_SUCCESS = "ORDER_HISTORY_LIST_SUCCESS"
export const ORDER_HISTORY_LIST = "ORDER_HISTORY_LIST"

export const ORDER_STATUS_SUCCESS = "ORDER_STATUS_SUCCESS"
export const ORDER_STATUS = "ORDER_STATUS"

export const ORDER_SUMMARY_SUCCESS = "ORDER_SUMMARY_SUCCESS"
export const ORDER_SUMMARY = "ORDER_SUMMARY"

export const GET_ORDER_ENTRY_BANKS_LIST_SUCCESS = "GET_ORDER_ENTRY_BANKS_LIST_SUCCESS"
export const GET_ORDER_ENTRY_BANKS_LIST = "GET_ORDER_ENTRY_BANKS_LIST"

export const GET_NON_MF_SECURITIES_LIST_SUCCESS = "GET_NON_MF_SECURITIES_LIST_SUCCESS"
export const GET_NON_MF_SECURITIES_LIST = "GET_NON_MF_SECURITIES_LIST"

export const GET_NON_MF_HOLDINGS_LIST_SUCCESS = "GET_NON_MF_HOLDINGS_LIST_SUCCESS"
export const GET_NON_MF_HOLDINGS_LIST = "GET_NON_MF_HOLDINGS_LIST"

export const GET_HOLDING_COMMITMENT_INFO_SUCCESS = "GET_HOLDING_COMMITMENT_INFO_SUCCESS"
export const GET_HOLDING_COMMITMENT_INFO = "GET_HOLDING_COMMITMENT_INFO"

export const GET_NON_MF_BROKERS_LIST_SUCCESS = "GET_NON_MF_BROKERS_LIST_SUCCESS"
export const GET_NON_MF_BROKERS_LIST = "GET_NON_MF_BROKERS_LIST"

export const GET_BONDS_DP_ID_SUCCESS = "GET_BONDS_DP_ID_SUCCESS"
export const GET_BONDS_DP_ID = "GET_BONDS_DP_ID"

export const GET_SETTLEMENT_DETAILS_SUCCESS = "GET_SETTLEMENT_DETAILS_SUCCESS"
export const GET_SETTLEMENT_DETAILS = "GET_SETTLEMENT_DETAILS"

export const GET_COUNTER_PARTY_LIST_SUCCESS = "GET_COUNTER_PARTY_LIST_SUCCESS"
export const GET_COUNTER_PARTY_LIST = "GET_COUNTER_PARTY_LIST"

export const GET_TRADE_CALCULATION_SUCCESS = "GET_TRADE_CALCULATION_SUCCESS"
export const GET_TRADE_CALCULATION = "GET_TRADE_CALCULATION"

export const GET_BANK_BALANCE_SUCCESS = "GET_BANK_BALANCE_SUCCESS"
export const GET_BANK_BALANCE = "GET_BANK_BALANCE"

export const GET_BROKER_BANK_DETAILS_SUCCESS = "GET_BROKER_BANK_DETAILS_SUCCESS"
export const GET_BROKER_BANK_DETAILS = "GET_BROKER_BANK_DETAILS"

export const GET_DEMAT_DETAILS_SUCCESS = "GET_DEMAT_DETAILS_SUCCESS"
export const GET_DEMAT_DETAILS = "GET_DEMAT_DETAILS"

export const ADVISORY_BANK_DETAILS_SUCCESS = "ADVISORY_BANK_DETAILS_SUCCESS"
export const ADVISORY_BANK_DETAILS = "ADVISORY_BANK_DETAILS"

export const RESIDENT_STATUS_TYPE_FILTER_SUCCESS = "RESIDENT_STATUS_TYPE_FILTER_SUCCESS"
export const RESIDENT_STATUS_TYPE_FILTER = "RESIDENT_STATUS_TYPE_FILTER"

export const MODE_OF_HOLDING_TYPE_FILTER_SUCCESS = "MODE_OF_HOLDING_TYPE_FILTER_SUCCESS"
export const MODE_OF_HOLDING_TYPE_FILTER = "MODE_OF_HOLDING_TYPE_FILTER"

export const NON_MF_ORDERS_EXCEL_REPORT_SUCCESS = "NON_MF_ORDERS_EXCEL_REPORT_SUCCESS"
export const NON_MF_ORDERS_EXCEL_REPORT = "NON_MF_ORDERS_EXCEL_REPORT"

export interface NonMfOrdersExcelReportReq {
    rmId: string;
    transactionType: string[];
    productType: string[];
    paymentStatus: string[];
    approvalStatus?: string[];
    investorType?: string[];
    modeOfHolding?: string[];
    searchInput: string;
    sort: string;
    order: string;
    currentPage: number;
    rowsPerPage: number;
}

export interface GetOrderEntryInvestorListRequestBody {
    rmId: string;
}

export interface GetOrderEntryInvestorListResponseData {
    clientCode: string;
    customerName: string;
    investorType: string;
    isFamilyHead: string;
    customerType: string;
    custStatus: string;
    rmId: string;
    rmName: string;
    panNo: string;
    portfolios: {
        portfolioName: string;
        portfolioId: string;
        accountType: string;
        email: string;
        portfolioCcy: string;
        portfolioNo: string;
        exchange: string;
        modeOfHolding: string;
        investorType: string;
        customerType: string;
        custStatus: string;
        rmId: string;
        rmName: string;
    }[],
}

export interface GetOrderEntryInvestorListResponseBody {
    result: GetOrderEntryInvestorListResponseData[];
    isSuccess: boolean;
    message: string;
}

export interface OrderSummaryTableData {
    product: string;
    ordersPlaced: number;
    settlementCompleted: number;
    settlementPending: number;
    settlementNotRequired: number;
}

export interface OrderHistoryTableData {
    clientName: string;
    productType: string;
    orderNumber: string;
    orderDate: string;
    orderAmount: string;
    transactionType: string;
    approvalStatus: string;
    paymentStatus: string;
    id?: string;
    cartId?: string | number;
    productOrderTableId?: string | number;
    accountType?: string;
    clientCode?: string;
    investorType?: string;
    modeOfHolding?: string;
}

export interface AddOrderEntryRequestBody {
    [key: string]: any
}

export interface AddOrderEntryResponseBody {
    isSuccess: boolean;
    message: string;
}

export interface ProductTypeFilter {
    orderStatusId: string;
    orderStatusValue: string;
    checked?: boolean
}

export interface TransactionTypeFilter {
    orderStatusId: string;
    orderStatusValue: string;
    checked?: boolean
}

export interface PaymentTypeFilter {
    orderStatusId: string;
    orderStatusValue: string;
    checked?: boolean
}

export interface OrderHistoryListReq {
    rmId: string;
    sort: string;
    order: string;
    transactionType: Array<string>;
    productType: Array<string>;
    paymentStatus: Array<string>;
    approvalStatus?: Array<string>;
    investorType?: Array<string>;
    modeOfHolding?: Array<string>;
    searchInput: string;
    currentPage: number;
    rowsPerPage: number;
}

export interface OrderListObj {
    id: string;
    clientName: string;
    productType: string;
    orderNumber: string;
    orderDate: string;
    accountType: string;
    approvalStatus: string;
    orderApprovalRequired: string;
    paymentApprovalRequired: string;
    orderAmount: string;
    transactionType: string;
    clientCode: string;
    portfolioId: string;
    portfolioName: string | null;
    rmId: string;
    approverId: string | null;
    orderStatus: string;
    paymentStatus: string;
    productOrderTableId: string;
    createdAt: string;
    updatedAt: string;
    cartId?: number | string;
    checkerRemarks?: string;
    investorType?: string;
    modeOfHolding?: string;
}

export interface OrderHistoryRes {
    orders: Array<OrderListObj>;
    totalCount: number;
}

export interface OrderSummaryReq {
    startDate: string;
    endDate: string;
    rmId: string;
    sort: string;
    order: string;
}

export interface OrderSummaryRes {
    product: string;
    ordersPlaced: number;
    orderApproved: number;
    orderRejected: number;
    settlementPending: number;
    settlementNotRequired: number;
    approvalPending: number;
    settled: number;
}

export interface PaymentApprovalListObj {
    id: string;
    clientName: string;
    productType: string;
    orderNumber: string;
    orderDate: string;
    accountType: string;
    approvalStatus: string;
    orderApprovalRequired: string;
    paymentApprovalRequired: string;
    orderAmount: string;
    transactionType: string;
    clientCode: string;
    portfolioId: string;
    portfolioName: string | null;
    rmId: string;
    approverId: string | null;
    paymentStatus: string;
    productOrderTableId: string;
    checkerRemarks: string | null,
    paymentCheckerRemarks: string | null,
    createdAt: string;
    updatedAt: string;
    cartId?: number | string;
    investorType?: string;
    modeOfHolding?: string;
}
export interface GetOrderEntryBanksListRequestBody {
    clientCode: string;
}

export interface BankDetails {
    division: string;
    bankCode: string;
    bankAccountInfo: string;
    bankAccCcy: string;
    bankAccHolder: string;
    branchName: string;
    bankAccType: string;
    company: string;
    bankAccNo: string;
    ifscCode: string;
    customer: string;
    isDefaultBankAc: string;
    bankname: string | null;
    subAccountType: string | null;
}

export interface GetOrderEntryBanksListResponseBody {
    isSuccess: boolean;
    bankDetails: Array<BankDetails>
}

export interface GetNonMfSecuritiesListRequestBody {
    product: string;
    searchInput: string;
}

export interface GetNonMfHoldingsListRequestBody {
    product: string;
    portfolioId: string;
    searchInput: string;
}

export interface GetNonMfBrokersListRequestBody {
    searchInput: string;
}

export interface GetNonMfBrokersListResponseBody {
    brokers: Array<
        {
            identifier: string;
            description: string;
            bankCode: string | null;
            bankAccCcy: string | null;
            bankAccHolder: string | null;
            bankName: string | null;
            bankAccType: string | null;
            bankAccNo: string | null;
            ifscCode: string | null;
            branch: string | null;
            bankAccCode: string | null;
        }
    >
}

export interface GetBondsDpIdRequestBody {
    portfolioId: string;
}

export interface GetBondsDpIdResponseBody {
    isSuccess: boolean;
    dpId: string;
    message: string;
}

export interface GetSettlementDetailsRequestBody {
    security: string;
    searchInput: string;
    product: string;
}

export interface GetSettlementDetailsResponseBody {
    isSuccess: boolean;
    message: string;
    settlementBanks: Array<{
        bankCode: string;
        bankAccCcy: string;
        description: string;
        bankAccType: string;
        bankAccNo: string;
        ifscCode: null;
        bankAccCode: string;
        bankName: string;
    }>
}

export interface GetCounterPartyListRequestBody {
    searchInput: string;
}

export interface CounterPartyBank {
    bankAccCcy: string;
    bankAccCode: string;
    bankAccHolder: string;
    bankAccNo: string;
    bankAccType: string;
    bankCode: string;
    bankName: string;
    branch: string;
    ifscCode: string;
}
export interface GetCounterPartyListResponseBody {
    counterPartyList: Array<{
        identifier: string;
        description: string;
        banks: Array<CounterPartyBank>
    }>
}

export interface GetTradeCalculationRequestBody {
    portfolioId: string;
    security: string;
    quantity: number;
    price: number;
    transactionType: string;
}

export interface TradeCalculationData {
    company: string;
    division: string;
    portfolio: string;
    security: string;
    transCode: string;
    quantity: number;
    price: number;
    netAmountPcy: number;
    netAmountTcy: number;
    acquCostTcy: number;
    acquCostPcy: number;
    grossAmtPcy: number;
    grossAmtTcy: number;
    feeTotalCapPcy: number;
    feeTotalCapTcy: number;
    feeTotalExpPcy: number;
    feeTotalExpTcy: number;
    purchaseYield: number;
    grossIntTcy: number;
    grossIntPcy: number;
    realGlPcy: number;
    realGlTcy: number;
}

export interface GetTradeCalculationResponseBody {
    isSuccess: boolean;
    message: string;
    tradeCalculationData: TradeCalculationData
}

export interface GetBankBalanceRequestBody {
    investorBankAccount: string;
    clientCode: string;
    investorIfscCode: string;
}

export interface GetBankBalanceResponseBody {
    isSuccess: boolean;
    message: string;
    bankBalance?: string | number;
    netAmount?: string | number;
    utilizedAmount?: string | number;
}

export interface GetBrokerBankDetailsRequestBody {
    clientCode: string;
    portfolioId: string;
}

export interface GetBrokerBankDetailsResponseBody {
    bankAccNo: string;
    bankName: string;
    ifscCode: string;
    beneficiaryName: string;
    bankBranch: string;
    bankAccType: string;
}

export interface GetDematDetailsRequestBody {
    portfolioId: string;
    clientCode: string;
    depositoryName: string;
}

export interface DematDetailsObj {
    clientId: string;
    dpName: string;
    depositoryId: string;
    dpCode: string;
    depositoryName: string;
    customer: string;
}

export interface GetDematDetailsResponseBody {
    isSuccess: boolean;
    message: string;
    result: Array<DematDetailsObj>
}

export interface GetAdvisoryBankDetailsResponseBody {
    bankAccNo: string;
    bankName: string;
    ifscCode: string;
    beneficiaryName: string;
    bankBranch: string;
    bankAccType: string;
}

export interface ResidentStatusTypeFilter {
    orderStatusId: string;
    orderStatusValue: string;
    checked?: boolean
}

export interface ModeOfHoldingTypeFilter {
    orderStatusId: string;
    orderStatusValue: string;
    checked?: boolean
}

export interface GetHoldingCommitmentInfoRequestBody {
    security: string;
    portfolio: string;
    folioNo: string;
}

export interface GetHoldingCommitmentInfoResponseBody {
    isSuccess: boolean;
    message: string;
    data: {
        security: string;
        folioNo: string;
        portfolio: string;
        commitmentAmount: number;
    };
}
